import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { PreSales1ModalComponent } from '../pre-sales1-modal/pre-sales1-modal.component';
import { PlatformDialogTestComponent } from '../../platform/platform-dialog-test/platform-dialog-test.component';
import { UserService } from 'src/app/services/user.service';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { MarketingApiService } from 'src/app/services/api/marketing-api.service';
import { CustomerServiceDialogComponent } from '../../page/customer-service-dialog/customer-service-dialog.component';

@Component({
  selector: 'app-pre-sales2-modal',
  templateUrl: './pre-sales2-modal.component.html',
  styleUrls: ['./pre-sales2-modal.component.scss'],
})
export class PreSales2ModalComponent implements OnInit {
  constructor(
    private modal: MatDialog,
    private modalRef: MatDialogRef<PreSales2ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiUser: UserApiService,
    private user: UserService,
    private apiMarketing: MarketingApiService
  ) {}

  ngOnInit(): void {
    this.findArticlePlatform();
  }

  openPreSales1Modal() {
    this.modalRef.close();
    this.modal.open(PreSales1ModalComponent, {
      width: '712px',
    });
  }

  purchase() {
    this.modal.open(PlatformDialogTestComponent, {
      data: Object.assign({}, this.data),
      autoFocus: false,
      panelClass: 'app-dialog',
    });
  }

  showCustomerService() {
    this.modal.open(CustomerServiceDialogComponent, {
      panelClass: 'app-dialog',
      autoFocus: false,
    });
  }

  loading = false;
  page = 1;
  total = 0;
  articles: any;
  async findArticlePlatform() {
    try {
      this.loading = true;
      this.articles = [];
      const r = await this.apiMarketing.findArticlePlatform(
        this.data.id,
        'presale',
        this.page,
        4
      );
      this.articles = r.data.list;
      this.total = r.data.total;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  changePage() {
    if (this.page * 4 < this.total) {
      this.page = this.page + 1;
    } else {
      this.page = 1;
    }
    this.findArticlePlatform();
  }
}
